import {
  icStreamContext,
  useCreateICStreamContext,
} from '@/pages/funds/ic-report/ic-report-context.context'

export const ICReportProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const context = useCreateICStreamContext()
  return <icStreamContext.Provider value={context}>{children}</icStreamContext.Provider>
}
